import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import LangfusePromptsIndex from '@/components/admin/LangfusePrompts/Index';
import LangfuseTracesIndex from '@/components/admin/LangfuseTraces/Index';
import DevDashboard from '../DevView/DevDashboard';
import type { DevTool } from '../DevView/DevDashboard';

/* eslint-disable max-len */
const LANGFUSE_TOOLS: DevTool[] = [
  { description: 'Browse, version, edit, and test prompts.', href: '/sysadmin/langfuse/prompts', routerPath: '/langfuse/prompts', title: 'Prompt Management' },
  { description: 'Look up LLM completions and traces by model record.', href: '/sysadmin/langfuse/traces', routerPath: '/langfuse/traces', title: 'Trace Viewer' },
];
/* eslint-enable max-len */

// AIDEV-NOTE: The prompts and traces pages own their SPAPageHeader (the prompts title is the
// selected prompt), so this is the page frame only.
const LangfusePage = ({ children }: { children: React.ReactNode }) => (
  <div className="tw-min-h-screen tw-bg-spa-bg tw-text-spa-on-bg">
    <div className="tw-mx-auto tw-max-w-[1400px] tw-px-6 tw-py-4">{children}</div>
  </div>
);

const LangfuseView = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route element={<LangfusePage><LangfusePromptsIndex /></LangfusePage>} path="/prompts" />
      <Route element={<LangfusePage><LangfuseTracesIndex /></LangfusePage>} path="/traces" />
      <Route
        element={(
          <DevDashboard
            description="Prompt management and trace lookup for the platform's LLM calls."
            title="Langfuse"
            tools={LANGFUSE_TOOLS}
            onNavigate={navigate}
          />
        )}
        path="/"
      />
    </Routes>
  );
};

export default LangfuseView;
